import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router';

import ContactButton from '../components/contact/ContactButton';

import BlockWrapper from '../components/blocks/BlockWrapper';
import PortfolioItem from '../components/portfolio/PortfolioItem';
import IconBlock from '../components/blocks/IconBlock';
import GenericBlock from '../components/blocks/GenericBlock';
import Slider from '../components/Slider';
import QuoteBar from '../components/QuoteBar';

import './Portfolio.css';

import backgroundImage from '../resources/img/slider-bg-pic2.jpg';

class Portfolio extends Component {

    renderPortfolioItem(item, index) {
        return (<PortfolioItem key={index} item={item} />)
    }

    render() {
        var pageTitle = 'Portfolio';
        document.title = 'TROI Studio | '+ pageTitle;

        var textLeft = (
            <h2>
                We are proud to present our work and clients. <br />
                We hope to work with you as a strategic thinking and production partner.
            </h2>
        );

        var textRight = (
            <span>{pageTitle.toUpperCase()}</span>
        );

        var portfolioItems = [
            {
                title: 'Driving Hotel Revenues Module',
                client: 'Ecole hôtelière de Lausanne (EHL)',
                description: (
                    <div>
                        <p>Purpose: Create a compelling marketing video which explains the relevance of several online MBA courses in the Hotel Revenue domain to managers aged 25-35 years. The video is used on Youtube in the EHL Publication Channel.</p>
                        <p>Production: TROI delivered the creative concept and execution. We work directly with the marketing, education and faculty teams to film on location in Switzerland. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'DvlUSA2TZkc'
            }, {
                title: 'World Talent Report 2016',
                client: 'IMD World Competitiveness Center',
                description: (
                    <div>
                        <p>Purpose: Using video as a method to transfer academic research results, TROI was asked to visualise a large quantity of data and to come up with attractive animations. The video is used on Youtube and on IMD website aimed at the professional press.</p>
                        <p>Production: TROI delivered the creative concept and execution. Recording was done in green screen studios. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'CT3c-WIUAZk'
            }, {
                title: 'Commercial Shopping Center Development',
                client: 'CBRE Global Investors',
                description: (
                    <div>
                        <p>Purpose: Inform and involve investors and stakeholders in the ongoing development of commercial assets. Explain the before and after stages over the course of 3 years and document the strategic decisions which improve results.</p>
                        <p>Production: TROI deliveres the creative concept and functions as CBRE’s European Video Hub. We take care of the complete production and dissemination process. Recording is done across Europe. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'wCXKhnwzeb0'
            }, {
                title: 'Revenue Management for Market Leaders',
                client: 'Ecole hôtelière de Lausanne (EHL)',
                description: (
                    <div>
                        <p>Purpose: Create an introduction video of the ‘Revenue Management Course’ aimed at stimulating the online purchase by potential students. The video is used on Youtube in the EHL Publication Channel.</p>
                        <p>Production: TROI delivered the creative concept and execution. Recording was done in green screen studios. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'Ali1gj_DcSg'
            }, {
                title: 'World Competitiveness Center: Mega Dive',
                client: 'IMD World Competitiveness Center',
                description: (
                    <div>
                        <p>Purpose: TROI consultants delivered process facilitation. We supported the IMD faculty in designing and delivering high-quality visual communication to steer a group of 350 cross-functional executives through a design-thinking process. </p>
                        <p>Production: TROI delivered the blue-print production guide and, as team members, orchestrated the event in Bangkok, Thailand. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'cGXPV3UsYdA'
            }, {
                title: 'Hotel Digital Marketing',
                client: 'Ecole hôtelière de Lausanne (EHL)',
                description: (
                    <div>
                        <p>Purpose: Create an introduction video of the ‘Digital Marketing Course’ aimed at stimulating the online purchase by potential students. The video is used on Youtube in the EHL Publication Channel as well as on the institution’s website.</p>
                        <p>Production: TROI delivered the creative concept and execution. Recording was done in green screen studios. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: '2t7w1uLT6jc'
            }, {
                title: 'Cocktail Trends',
                client: 'Head Bartender W Hotel',
                description: (
                    <div>
                        <p>Purpose: Promote the launch of a new cocktail in one of the world’s leading cocktail lounges. The Cocktail Trends format is part of a growing series of Hospitality related productions by TROI Studio.</p>
                        <p>Production: TROI delivered the format and creative concept. We took care of the complete production and dissemination process. Recording was done in leading hotel lounges globally. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: '6cT1FNxVKN8'
            }, {
                title: 'Hotel Distribution Management',
                client: 'Ecole hôtelière de Lausanne (EHL)',
                description: (
                    <div>
                        <p>Purpose: Create an introduction video of the ‘Distribution Management Course’ aimed at stimulating the online purchase by potential students. The video is used on Youtube in the EHL Publication Channel as well as on the institution’s website.</p>
                        <p>Production: TROI delivered the creative concept and execution. Recording was done in green screen studios. Post-Production and animation took place in Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'lb1H9uWKOtU'
            }, {
                title: 'Employee Video Reporters create great stories',
                client: 'Nike',
                description: (
                    <div>
                        <p>Purpose: The challenge for many Learning & Development Managers is to make the impact of training visible. TROI’s Employee Video Reporter Format teaches employees to document training impact into ‘case videos’. Your efforts in building great career development opportunities will become highly visible inside the organisation.</p>
                        <p>Production: TROI creates the custom-made format, the training and creative support so your people can make great video content. Recording can be done in any city around the world with post-production and animation support from Amsterdam, the Netherlands.</p>
                    </div>
                ),
                videoId: 'yeJ6cMFgJKs'
            }, {
                title: 'Video Storytelling Workshops',
                client: 'TNT',
                description: (
                    <div>
                        <p>Purpose: Many great ideas go unnoticed. TROI facilitates interactive workshops and lectures which train employees to deliver strong pitches to the Board, and the cross media materials to creating lasting impressions. This improves the likelihood of implementation.</p>
                        <p>Production: Training can be done as part of your development modules. Typically we need 2 x 2 hour classroom sessions, with 2 days in between. By the end of these sessions the participants will have a strong script for their presentation and video. Additional on-site production and post-production support can come from teams of TROI Digital Designers.</p>
                    </div>
                ),
                videoId: 'p8P9_w3AdD8'
            }, {
                title: 'TalentPass App - concept',
                client: '',
                description: (
                    <div>
                        <p>The rationale behind TalentPass is to stimulate personal development by 1) letting your people take ownership of their own training and 2) focusing on getting knowledge into action. The TalentPass can be configured towards required future competencies to make your organisation future-proof and to ensure your people are prepared. The idea is to make performance evaluations peer-to-peer (social). Ideally a company would integrate job opportunities into the app. That would be truly rewarding your people!</p>
                    </div>
                ),
                imageUrl: require('../resources/portfolio/Deloitte_TalentPass_Concept.jpg')
            }
        ];

        var textBox = (
            <GenericBlock>
                <Col md={12}>
                    <h3>{pageTitle}</h3>
                    <p>
                        TROI has produced over 1500 videos. Not everything can be displayed here, but rest assured we have examples of what you need. <Link to="/contact">Contact us</Link> for more information.
                    </p>
                </Col>

                <Col md={12}>
                    {portfolioItems.map(this.renderPortfolioItem.bind(this))}
                </Col>
            </GenericBlock>
        );

        return (
            <div>
                <ContactButton />

                <Slider backgroundImage={backgroundImage}
                    textLeft={textLeft}
                    textRight={textRight} />
                <QuoteBar text="" />

                <BlockWrapper>
                    <IconBlock className="hidden-xs hidden-sm" icon="play">
                        <h3>{pageTitle}</h3>
                    </IconBlock>

                    {textBox}
                </BlockWrapper>
            </div>
       );
    }

}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/pages/Portfolio.js